export interface ColorGroup {
    light: string;
    main: string;
    dark: string;
}

export interface Color {
    black: string;
    white: string;
    background: string;
    text: string;
    primary: ColorGroup;
    secondary: ColorGroup;
    accent: ColorGroup;
    success: string;
    error: string;
}

// TODO: I'm guessing on most of the colors for now.
export function createColor(props: Partial<Color> = {}): Color {
    return {
        black: '#000',
        white: '#fff',
        background: '#2a2a2a',
        text: '#ffffff72',
        accent: {
            light: '#33abff',
            main: '#0074E4',
            dark: '#0045bf'
        },
        primary: {
            light: '#272727',
            main: '#141414',
            dark: '#0B0B0B'
        },
        secondary: {
            light: '#3A3A3A',
            main: '#3A3A3A',
            dark: '#3A3A3A'
        },
        success: '#95c990',
        error: '#dc5353',
        ...props
    };
}
